export const onBeforeNumberInput = (e: any) => {
  // copy-paste number like '123,444.99'
  if (typeof e.data === 'string' && e.data.length > 1) {
    if (e.data.includes(',')) {
      e.data = e.data.replace(',', '');
    }
    const isNumeric = isNumericString(e.data);
    return isNumeric ? null : e.preventDefault();
  }

  if (!'.0123456789'.split('').includes(e.data)) {
    return e.preventDefault();
  }

  if (`${e.target.value}`.includes('.')) {
    if (e.data === '.') return e.preventDefault();
    const [, cents] = e.target.value.split('.');
    if (cents.length >= 2) return e.preventDefault();
  }
};

const isNumericString = (str: string): boolean => {
  if (typeof str !== 'string') return false;

  return !isNaN(str as any) && !isNaN(parseFloat(str));
};
